/* ARCHIVE — product page: variants, gallery, zoom, sticky bar */
(() => {
  document.querySelectorAll('[data-product-section]').forEach(initProduct);

  function initProduct(root) {
    const sectionId = root.dataset.productSection;
    const productUrl = root.dataset.url;
    const picker = root.querySelector('[data-variant-picker]');
    const variantsEl = picker && picker.querySelector('[data-variants]');
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const idInput = root.querySelector('[data-variant-id]');
    const gallery = document.getElementById('Gallery-' + sectionId);
    const counter = root.querySelector('[data-counter]');
    const sticky = document.getElementById('StickyATC-' + sectionId);
    const lightbox = document.getElementById('Lightbox-' + sectionId);

    /* ---- Variant selection ---- */
    const selected = () => {
      const vals = [];
      picker.querySelectorAll('input[type=radio]:checked').forEach(i => { vals[Number(i.dataset.optionIndex)] = i.value; });
      return vals;
    };

    const markAvailability = (vals) => {
      picker.querySelectorAll('input[type=radio]').forEach(input => {
        const idx = Number(input.dataset.optionIndex);
        const test = vals.slice(); test[idx] = input.value;
        const ok = variants.some(v => v.available && v.options.every((o, i) => i === idx || test[i] === undefined || o === test[i]) && v.options[idx] === input.value);
        input.classList.toggle('is-na', !ok);
      });
    };

    let controller;
    const onChange = async () => {
      const vals = selected();
      vals.forEach((v, i) => { const lab = picker.querySelector(`[data-option-value="${i}"]`); if (lab) lab.textContent = v; });
      markAvailability(vals);
      const variant = variants.find(v => v.options.every((o, i) => o === vals[i]));
      const atc = root.querySelector('[data-atc]');
      if (!variant) {
        if (idInput) idInput.value = '';
        if (atc) { atc.disabled = true; atc.textContent = theme.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (variant.featured_media && gallery) scrollToMedia(variant.featured_media.id);

      // Re-render dynamic pieces from the server so price formats, stock & payment terms stay exact
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const html = await fetch(`${productUrl}?variant=${variant.id}&section_id=${sectionId}`, { signal: controller.signal }).then(r => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        ['price', 'stock', 'atc', 'ticket', 'sticky-variant'].forEach(key => {
          const fresh = doc.querySelector(`[data-swap="${key}"]`);
          const cur = document.querySelector(`#shopify-section-${sectionId} [data-swap="${key}"], [data-swap="${key}"]`);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        const freshTerms = doc.querySelector('shopify-payment-terms');
        const curTerms = root.querySelector('shopify-payment-terms');
        if (freshTerms && curTerms) curTerms.replaceWith(freshTerms);
        const sBtn = sticky && sticky.querySelector('[data-sticky-atc]');
        if (sBtn) {
          sBtn.disabled = !variant.available;
          sBtn.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
      } catch (e) { /* aborted */ }
    };

    if (picker && variants.length) {
      picker.addEventListener('change', onChange);
      markAvailability(selected());
    }

    /* ---- Gallery ---- */
    function scrollToMedia(mediaId) {
      const slide = gallery.querySelector(`[data-media-id="${mediaId}"]`);
      if (!slide) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      } else {
        const top = slide.getBoundingClientRect().top + window.scrollY - 90;
        if (Math.abs(top - window.scrollY) > 40) window.scrollTo({ top, behavior: 'smooth' });
      }
    }

    if (gallery && counter) {
      const total = gallery.children.length;
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        counter.textContent = `${i + 1} / ${total}`;
      }, { passive: true });
    }

    /* ---- Zoom lightbox ---- */
    if (gallery && lightbox) {
      gallery.addEventListener('click', (e) => {
        const slide = e.target.closest('.pdp__slide');
        if (!slide || !slide.querySelector('img')) return;
        const imgs = Array.from(gallery.querySelectorAll('.pdp__slide img'));
        const idx = imgs.indexOf(slide.querySelector('img'));
        window.openPanel(lightbox);
        const target = lightbox.querySelector(`[data-lightbox-index="${idx}"]`);
        if (target) requestAnimationFrame(() => { lightbox.scrollTop = target.offsetTop; });
      });
      lightbox.addEventListener('click', (e) => { if (e.target.tagName === 'IMG') window.closePanel(lightbox); });
    }

    /* ---- Sticky add-to-bag ---- */
    const atcAnchor = root.querySelector('[data-atc]');
    if (sticky && atcAnchor && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      });
      io.observe(atcAnchor.closest('form') || atcAnchor);
    }
  }
})();
